import { render, staticRenderFns } from "./PdpTabInfoTexts.vue?vue&type=template&id=29ef9147&scoped=true"
import script from "./PdpTabInfoTexts.vue?vue&type=script&lang=js"
export * from "./PdpTabInfoTexts.vue?vue&type=script&lang=js"
import style0 from "./PdpTabInfoTexts.vue?vue&type=style&index=0&id=29ef9147&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ef9147",
  null
  
)

export default component.exports